import {
  Box,
  SxProps,
  Theme,
  Typography,
  TypographyProps,
} from "@mui/material";
import { FC } from "react";

import PriceMUI from "web/Layout/Common/PriceMUI";
import __ from "web/Layout/Translations";

interface ITotalRow {
  containerKey?: string;
  containerDataT1?: string;
  containerSx?: SxProps<Theme>;
  titleDataT1?: string;
  titleValue: string;
  titleSx?: SxProps<Theme>;
  titleVariant?: TypographyProps["variant"];
  priceDataT1?: string;
  priceValue?: string | number;
  priceCurrency: string;
  priceSize?: string;
}

const TotalRow: FC<ITotalRow> = ({
  containerKey,
  containerDataT1,
  containerSx = {},
  titleDataT1,
  titleValue,
  titleSx = {},
  titleVariant = "body2",
  priceDataT1,
  priceValue,
  priceCurrency,
  priceSize = "S",
}) => (
  <Box
    key={containerKey}
    sx={{
      display: "flex",
      justifyContent: "space-between",
      borderBottom: "none",
      mt: "8px",
      ...containerSx,
    }}
    data-t1={containerDataT1}
  >
    <Box
      data-t1={titleDataT1}
      sx={{
        pr: "8px",
        ...titleSx,
      }}
    >
      <Typography variant={titleVariant}>{__(titleValue)}</Typography>
    </Box>

    <Box
      data-t1={priceDataT1}
      sx={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <PriceMUI
        value={priceValue}
        currency={__(priceCurrency)}
        size={priceSize}
      />
    </Box>
  </Box>
);

export default TotalRow;
